class TrFacetsClear extends HTMLElement {
	selectors = {
		clearLink: '[data-tr-js-facets-clear-link]'
	};

	attributes = {
		sectionId: 'section-id'
	};

	stateClasses = {};

	connectedCallback() {
		this.clearLinkElement = this.querySelector(this.selectors.clearLink);

		this.bindEvents();
	}

	disconnectedCallback() {
		this.destroy();
	}

	bindEvents() {
		this.clearLinkElement?.addEventListener('click', this.onClearLinkClick);
	}

	onClearLinkClick = async (event) => {
		event.preventDefault();

		const url = new URL(this.clearLinkElement.href);
		const sectionId = this.getAttribute(this.attributes.sectionId);
		const drawerElement = this.closest('facets-drawer');

		if (sectionId) {
			url.searchParams.set('section_id', sectionId);
		}

		await drawerElement?.hide();

		this.dispatchEvent(
			new CustomEvent('facet:update', {
				bubbles: true,
				detail: { url }
			})
		);
	};

	destroy() {
		this.clearLinkElement?.removeEventListener('click', this.onClearLinkClick);
	}
}

if (!customElements.get('tr-facets-clear')) {
	customElements.define('tr-facets-clear', TrFacetsClear);
}
